import type { JSX } from 'react';
const Dashboard = (): JSX.Element | null => {
  return (
    <div>
      <p>Dashboard</p>
    </div>
  );
};

export default Dashboard;
